import { getFilterMsg, saveUnFilterMsg } from "@/api/FilterSet";
const state = {
  getFilterMsg:{},
};

const mutations = {
  SET_DATA: (state, {key,data}) => {
    state[key] = data;
  }
};

const actions = {
  getFilterMsg({ commit },data) { 
    return new Promise((resolve)=>{
      getFilterMsg(data).then(res => {
        try {
          var { data } = res;
          var newData = JSON.parse(
            JSON.stringify(data.data).replace(/label/g, "text")
          );
          commit("SET_DATA", {key:'getFilterMsg',data:newData});
        } catch (error) {
          console.log(error)  
        }
        resolve( res.data )
      });
    })
  },

  saveUnFilterMsg({ commit },data) { 
    return new Promise((resolve)=>{
      saveUnFilterMsg(data).then(res => {
        try {
          var { data } = res;
          var newData = JSON.parse(
            JSON.stringify(data.data).replace(/label/g, "text")
          );
          commit("SET_DATA", {key:'saveUnFilterMsg',data:newData});
        } catch (error) {
          console.log(error)  
        }
        resolve( res.data )
      });
    })
  },
};

export default {
  namespaced: true,
  state,
  mutations,
  actions
};
